import { spacing } from '../spacing'

const sm = spacing(0, 0, 1, 0)
const md = spacing(0, 0.5, 3, 0)
const lg = spacing(0, 1, 5, 0)

export type Elevation = 'sm' | 'md' | 'lg'

export const elevation: Record<Elevation, string> = {
  sm: `${sm} rgba(0, 0, 0, 0.06)`,
  md: `${md} rgba(0, 0, 0, 0.08)`,
  lg: `${lg} rgba(0, 0, 0, 0.10)`,
}
